import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { serverURL } from "../components/networking";
import TreePointCloud from "./TreePointCloud";

/// For displaying the date in a user-friendly format
function displayDate(date_collected) {
    var date = new Date(date_collected);
    var time = date.toUTCString().slice(-12);
    var ret = date.toUTCString();
    if (time === "00:00:00 GMT") {
        ret = ret.slice(0, -12);
    }
    return ret;
}

export default function ReportList() {
    // Get List of Reports from Server
    const [reports, setReports] = useState([]);
    const navigate = useNavigate();

    let csrf = document.cookie.replace(
        /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
        "$1",
    );
    useEffect(() => {
        axios
            .get(serverURL + "/api/plot/", {
                withCredentials: true,
                headers: {
                    "X-CSRFToken": csrf,
                },
            })
            .then(function (response) {
                setReports(sortPlots(response.data.plots));
                console.log(response.data.plots);
            })
            .catch(function (error) {
                console.log(error.response);
                navigate("/");
            });
    }, []);

    function DeletePlot(plot_id) {
        let csrf = document.cookie.replace(
            /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
            "$1",
        );
        axios
            .post(
                serverURL + "/api/plot/delete/",
                { plot_id: plot_id, user_id: sessionStorage.user_id },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                console.log(response);
                window.location.reload();
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    function ShowPopUp(plot_id) {
        if (
            window.confirm(
                "Are you sure you want to delete this plot? This action cannot be undone.",
            )
        ) {
            DeletePlot(plot_id);
        }
    }

    /// For checking how the user wants their plots ordered and sorting the plots
    /// appropriately. If the user has not made a selection, "Sort by newest"
    /// is selected for them.
    function sortPlots(plots) {
        const sort = localStorage.getItem("sort");
        if (sort === null) {
            localStorage.setItem("sort", "NEW");
        }
        document.getElementById(sort).checked = true;
        if (sort === "NEW") {
            return plots.sort(
                (a, b) =>
                    Date.parse(b.date_collected) - Date.parse(a.date_collected),
            );
        } else if (sort === "OLD") {
            return plots.sort(
                (a, b) =>
                    Date.parse(a.date_collected) - Date.parse(b.date_collected),
            );
        } else if (sort === "ALPH") {
            return plots.sort((a, b) =>
                String(a.name).localeCompare(String(b.name)),
            );
        } else {
            throw new Error("Sorting method not implemented.");
        }
    }

    return (
        <div>
            <h1 className="section-title">Forest Report Data</h1>

            <input
                type="radio"
                id="NEW"
                name="sort"
                value="NEW"
                onClick={() => {
                    localStorage.setItem("sort", "NEW");
                    window.location.reload();
                }}
            ></input>
            <label htmlFor="NEW">Sort by Newest </label>
            <input
                type="radio"
                id="OLD"
                name="sort"
                value="OLD"
                onClick={() => {
                    localStorage.setItem("sort", "OLD");
                    window.location.reload();
                }}
            ></input>
            <label htmlFor="OLD">Sort by Oldest </label>
            <input
                type="radio"
                id="ALPH"
                name="sort"
                value="ALPH"
                onClick={() => {
                    localStorage.setItem("sort", "ALPH");
                    window.location.reload();
                }}
            ></input>
            <label htmlFor="ALPH">Sort by Name</label>

            <ul>
                {reports.length < 1 ? (
                    <p>
                        No reports found in account! Try uploading some forest
                        plot data!
                    </p>
                ) : (
                    reports.map((report) => (
                        <li key={report.plot_id} className="report-list-option">
                            <div
                                onClick={() =>
                                    navigate(
                                        "/home/reports?report=" +
                                            report.name +
                                            "&plotId=" +
                                            report.plot_id,
                                    )
                                }
                                className="plot-main-info"
                            >
                                <h4>
                                    Report:{" "}
                                    {report.file_status &&
                                    report.file_status === "draft"
                                        ? "(DRAFT) " + report.name
                                        : report.name}
                                </h4>
                                <p>
                                    Collected at{" "}
                                    {report.center_latitude.toFixed(6)}°,{" "}
                                    {report.center_longitude.toFixed(6)}°
                                </p>
                                <p>
                                    Collected on:{" "}
                                    {displayDate(report.date_collected)}
                                </p>
                            </div>
                            <div
                                onClick={() =>
                                    navigate(
                                        "/home/reports?report=" +
                                            report.name +
                                            "&plot_id=" +
                                            report.plot_id +
                                            "/",
                                    )
                                }
                                className="plot-notes"
                            >
                                <p>{report.notes}</p>
                            </div>
                            <div>
                                <button
                                    className="button"
                                    onClick={() => ShowPopUp(report.plot_id)}
                                >
                                    Delete
                                </button>
                            </div>
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
}

export function Report({ report, plotId }) {
    const [data, setData] = useState([]);
    const [valid, setValid] = useState(true);
    const [receivedResponse, setReceivedResponse] = useState(false);
    const [trees, setTrees] = useState([]);
    const [latValue, setLatValue] = useState("0.000000");
    const [lonValue, setLonValue] = useState("0.000000");

    const latValueChange = (event) => {
        setLatValue(event.target.value);
    };
    const lonValueChange = (event) => {
        setLonValue(event.target.value);
    };
    const [errorMessage, setErrorMessage] = useState("");

    const serverUpdateCoords = () => {
        axios
            .post(
                serverURL + "/api/plot/update-coords/",
                {
                    plot_id: plotId,
                    latitude: latValue,
                    longitude: lonValue,
                },
                {
                    withCredentials: true,
                    headers: {
                        "X-CSRFToken": csrf,
                    },
                },
            )
            .then(function (response) {
                console.log(response);
                window.location.reload();
            })
            .catch(function (error) {
                setErrorMessage(error.response.data.message);
                console.log(error);
            });
    };

    let csrf = document.cookie.replace(
        /(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/,
        "$1",
    );
    useEffect(() => {
        axios
            .get(serverURL + "/api/plot/", {
                withCredentials: true,
                headers: {
                    "X-CSRFToken": csrf,
                },
                params: {
                    plot_id: plotId,
                },
            })
            .then(function (response) {
                setReceivedResponse(true);
                console.log(response.data);
                setData(response.data.plot);
                if (response.data.plot.trees) {
                    setTrees(
                        response.data.plot.trees.sort(
                            (a, b) => a.tree_number - b.tree_number,
                        ),
                    );
                } else {
                    setTrees([]);
                }
                setLatValue(response.data.plot.center_latitude.toFixed(6));
                setLonValue(response.data.plot.center_longitude.toFixed(6));
            })
            .catch(function (error) {
                setReceivedResponse(true);
                console.log(error);
                setValid(false);
            });
    }, []);

    function getCSV(plotId) {
        axios({
            url: serverURL + "/api/csv/",
            method: "GET",
            headers: {
                "X-CSRFToken": csrf,
            },
            withCredentials: true,
            responseType: "blob",
            params: {
                plot_id: plotId,
            },
        })
            .then((response) => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data]),
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "trees_data.csv");
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch((error) => {
                console.error(
                    "There was an error downloading the file:",
                    error,
                );
            });
    }

    function displayDirection(tree) {
        var vertical = tree.y > 0 ? "m N, " : "m S, ";
        var horizontal = tree.x > 0 ? "m E" : "m W";

        return (
            Math.abs(tree.y.toFixed(3)) +
            vertical +
            Math.abs(tree.x.toFixed(3)) +
            horizontal
        );
    }
    function displayDisplacement(tree) {
        return Math.sqrt(Math.pow(tree.x, 2) + Math.pow(tree.y, 2)).toFixed(2);
    }
    function displayHeading(tree) {
        if (tree.y > 0) {
            return (
                (360 + (180 / Math.PI) * Math.atan(tree.x / tree.y)) %
                360
            ).toFixed(0);
        } else {
            return (
                180.0 +
                (180 / Math.PI) * Math.atan(tree.x / tree.y)
            ).toFixed(0);
        }
    }

    return (
        <div>
            <h1 className="section-title">
                Forest Report Data <br /> Report: {report}
            </h1>

            <Link href={{ pathname: "reports" }}>Return to Report List</Link>
            {receivedResponse ? (
                valid ? (
                    <div>
                        <h3 onClick={() => getCSV(plotId)}>Download .CSV</h3>
                        <h4>
                            Collected at:
                            <br />
                            Latitude:{""}
                            <input
                                type="text"
                                value={latValue}
                                onChange={latValueChange}
                                placeholder="Enter Coordinates Here"
                            />
                            <br />
                            Longitude:{"  "}
                            <input
                                type="text"
                                value={lonValue}
                                onChange={lonValueChange}
                                placeholder="Enter Coordinates Here"
                            />
                            <br />
                            <button onClick={serverUpdateCoords}>
                                Update Coordinates
                            </button>
                            <br />
                            <p>{errorMessage}</p>
                            <br />
                            Collected on: {displayDate(data.date_collected)}
                            <br />
                            {data.notes ? "Notes: " + data.notes : <></>}
                        </h4>
                        <ul>
                            {trees.length < 1 ? (
                                <p>No trees found in this plot!</p>
                            ) : (
                                trees.map((tree) => (
                                    <li
                                        key={tree.tree_id}
                                        className="report-list-option"
                                    >
                                        <div className="plot-main-info">
                                            <h4>Tree #{tree.tree_number}</h4>
                                            <ul>
                                                {tree.height ? (
                                                    <li>
                                                        Tree Height:{" "}
                                                        {tree.height.toFixed(
                                                            2,
                                                        ) + " m"}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                {tree.dbh ? (
                                                    <li>
                                                        Tree Diameter:{" "}
                                                        {(
                                                            Math.round(
                                                                tree.dbh *
                                                                    10000,
                                                            ) / 10000
                                                        ).toFixed(1) + " cm"}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                <li>
                                                    Tree Species:{" "}
                                                    {tree.species
                                                        ?.scientific_name ??
                                                        "No data"}
                                                </li>
                                                <li>
                                                    Tree Genus:{" "}
                                                    {tree.genus
                                                        ?.scientific_name ??
                                                        "No data"}
                                                </li>
                                                <li>
                                                    Tree Biomass:{" "}
                                                    {tree.biomass + " kg" ??
                                                        "No data"}
                                                </li>
                                                {tree.latitude &&
                                                tree.longitude ? (
                                                    <li>
                                                        Tree Location:{" "}
                                                        {tree.latitude.toFixed(
                                                            6,
                                                        ) +
                                                            "°, " +
                                                            tree.longitude.toFixed(
                                                                6,
                                                            ) +
                                                            "°"}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                {tree.x && tree.y ? (
                                                    <li>
                                                        Location relative to
                                                        plot center:{" "}
                                                        {displayDirection(tree)}
                                                    </li>
                                                ) : (
                                                    <></>
                                                )}
                                                {
                                                    <li>
                                                        Distance from Plot
                                                        Center:{" "}
                                                        {displayDisplacement(
                                                            tree,
                                                        )}
                                                        m
                                                    </li>
                                                }
                                                {
                                                    <li>
                                                        Direction from Plot
                                                        Center:{" "}
                                                        {displayHeading(tree)}°
                                                    </li>
                                                }

                                                <li>
                                                    Decay Level: {tree.decay}%
                                                </li>

                                                {tree.notes && (
                                                    <li>Notes: {tree.notes}</li>
                                                )}

                                                {tree.photo_paths &&
                                                    tree.photo_paths.map(
                                                        (url) => (
                                                            <li>
                                                                <img
                                                                    src={url}
                                                                    alt=""
                                                                    width="200"
                                                                ></img>
                                                            </li>
                                                        ),
                                                    )}
                                                <li>{tree.point_cloud}</li>
                                                {tree.point_cloud && (
                                                    <TreePointCloud
                                                        url={tree.point_cloud}
                                                    />
                                                )}
                                            </ul>
                                        </div>
                                    </li>
                                ))
                            )}
                        </ul>
                    </div>
                ) : (
                    <h4>Invalid Report</h4>
                )
            ) : (
                <h4> Loading </h4>
            )}
        </div>
    );
}
